(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHeader = () => {
    const header = document.querySelector('[data-ft-header]');
    if (!header) return;
    const mobile = header.querySelector('[data-ft-mobile]');
    const burger = header.querySelector('[data-ft-burger]');
    const searchWrap = header.querySelector('[data-ft-search]');
    const searchToggle = header.querySelector('[data-ft-search-toggle]');
    const menus = [...header.querySelectorAll('[data-ft-menu]')];

    const setMenu = (menu, open) => {
      menu.dataset.open = open ? 'true' : 'false';
      const toggle = menu.querySelector('[data-ft-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const closeMenus = (except) => menus.forEach((menu) => menu !== except && setMenu(menu, false));

    menus.forEach((menu) => {
      let timer;
      menu.querySelector('[data-ft-menu-toggle]')?.addEventListener('click', () => {
        const open = menu.dataset.open !== 'true';
        closeMenus(menu);
        setMenu(menu, open);
      });
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        closeMenus(menu);
        setMenu(menu, true);
      });
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => setMenu(menu, false), 180);
      });
    });

    const setMobile = (open) => {
      if (!mobile || !burger) return;
      if (open) mobile.style.top = `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`;
      mobile.hidden = !open;
      header.dataset.menu = open ? 'open' : 'closed';
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger?.addEventListener('click', () => setMobile(mobile.hidden));

    searchToggle?.addEventListener('click', () => {
      const open = searchWrap.dataset.open !== 'true';
      searchWrap.dataset.open = open ? 'true' : 'false';
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchWrap.querySelector('input[type="search"]')?.focus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeMenus();
      setMobile(false);
      if (searchWrap) searchWrap.dataset.open = 'false';
    });
    document.addEventListener('mousedown', (event) => {
      if (header.contains(event.target)) return;
      closeMenus();
      if (searchWrap) searchWrap.dataset.open = 'false';
    });

    const onScroll = () => {
      header.dataset.scrolled = window.scrollY > 24 ? 'true' : 'false';
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const initAnnouncements = () => {
    document.querySelectorAll('[data-ft-announce]').forEach((bar) => {
      const items = [...bar.querySelectorAll('.ft-announce-item')];
      if (items.length < 2) return;
      const interval = Number(bar.dataset.interval) || 5000;
      let index = 0;
      let held = false;
      const show = (next) => {
        items.forEach((item, i) => {
          item.dataset.active = i === next ? 'true' : 'false';
          if (i === next) item.removeAttribute('aria-hidden');
          else item.setAttribute('aria-hidden', 'true');
        });
      };
      ['mouseenter', 'focusin'].forEach((type) => bar.addEventListener(type, () => (held = true)));
      ['mouseleave', 'focusout'].forEach((type) => bar.addEventListener(type, () => (held = false)));
      setInterval(() => {
        if (held) return;
        index = (index + 1) % items.length;
        show(index);
      }, interval);
    });
  };

  const initReveal = () => {
    const shell = document.querySelector('[data-ft-shell]');
    if (!shell || reducedMotion || !('IntersectionObserver' in window)) return;
    shell.classList.add('ft-motion');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    );
    shell.querySelectorAll('.ft-reveal:not(.is-in)').forEach((el) => observer.observe(el));
  };

  const initLightbox = () => {
    const buttons = [...document.querySelectorAll('[data-ft-zoom]')];
    if (buttons.length === 0) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'ft-lightbox';
    dialog.innerHTML =
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<button type="button" class="ft-lightbox-btn ft-lightbox-close" aria-label="Close">&times;</button>' +
      '<button type="button" class="ft-lightbox-btn ft-lightbox-prev" aria-label="Previous photo">&larr;</button>' +
      '<button type="button" class="ft-lightbox-btn ft-lightbox-next" aria-label="Next photo">&rarr;</button>';
    document.body.appendChild(dialog);
    const img = dialog.querySelector('img');
    const caption = dialog.querySelector('figcaption');
    let current = 0;
    const show = (index) => {
      current = (index + buttons.length) % buttons.length;
      const button = buttons[current];
      img.src = button.dataset.ftZoom;
      img.alt = button.dataset.ftAlt || '';
      caption.textContent = button.dataset.ftAlt || '';
    };
    buttons.forEach((button, index) =>
      button.addEventListener('click', () => {
        show(index);
        dialog.showModal();
      }),
    );
    dialog.querySelector('.ft-lightbox-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('.ft-lightbox-prev').addEventListener('click', () => show(current - 1));
    dialog.querySelector('.ft-lightbox-next').addEventListener('click', () => show(current + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') show(current + 1);
      if (event.key === 'ArrowLeft') show(current - 1);
    });
  };

  const initProducts = () => {
    document.querySelectorAll('[data-ft-product]').forEach((root) => {
      const mainImage = root.querySelector('.ft-pdp-main img');
      const setImage = (src, alt) => {
        if (!mainImage || !src) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = src;
        if (alt !== undefined) mainImage.alt = alt;
      };
      root.querySelectorAll('[data-ft-thumb]').forEach((thumb) =>
        thumb.addEventListener('click', () => {
          root.querySelectorAll('[data-ft-thumb]').forEach((other) => other.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
          setImage(thumb.dataset.ftThumb, thumb.dataset.ftThumbAlt);
        }),
      );

      const data = root.querySelector('[data-ft-variants]');
      const form = root.querySelector('[data-ft-product-form]');
      if (!data || !form) return;
      const variants = JSON.parse(data.textContent);
      const idInput = form.querySelector('[data-ft-variant-id]');
      const addButton = form.querySelector('[data-ft-add]');
      const price = root.querySelector('.ft-pdp-price [data-ft-price]');
      const labels = { add: addButton.textContent.trim(), sold: addButton.dataset.soldOut || 'Sold out', unavailable: 'Unavailable' };
      const update = () => {
        const chosen = [...form.querySelectorAll('[data-ft-option]:checked')]
          .sort((a, b) => Number(a.dataset.ftOption) - Number(b.dataset.ftOption))
          .map((input) => input.value);
        const variant = variants.find((entry) => entry.options.every((value, i) => value === chosen[i]));
        if (!variant) {
          addButton.disabled = true;
          addButton.textContent = labels.unavailable;
          return;
        }
        idInput.value = variant.id;
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? labels.add : labels.sold;
        if (price) price.innerHTML = variant.price + (variant.compare ? ` <s>${variant.compare}</s>` : '');
        if (variant.image) setImage(variant.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      form.querySelectorAll('[data-ft-option]').forEach((input) => input.addEventListener('change', update));
    });
  };

  const initAutosubmit = () => {
    document.querySelectorAll('[data-ft-autosubmit]').forEach((select) =>
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set(select.name, select.value);
        window.location.href = url.toString();
      }),
    );
  };

  const start = () => {
    initHeader();
    initAnnouncements();
    initReveal();
    initLightbox();
    initProducts();
    initAutosubmit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', () => {
    initReveal();
    initLightbox();
    initProducts();
  });
})();

